/**
 * Facebook (and Instagram) make multiple formatting before publishing a post.
 *
 * 1 - remove multiple blank lines and replace them by one blank line
 * 2 - remove spaces and tabs on each lines
 * 3 - trim the posts
 * 4 - remove unusual separators (line separator and paragraph separator)
 * 5 - remove replacement character �
 *
 */
import { isNil } from 'es-toolkit/compat';

export function formatSocialNetworkPostText(postText: string): string {
    if (isNil(postText)) {
        return '';
    }

    let result = postText;

    const twoBlankLinesRegex = /\n\s*\n\s*\n/g;
    result = result.replace(twoBlankLinesRegex, '\n\n');

    const spacesAndTabsAtStartAndEndOfLineRegex = /^[ \t]+|[ \t]+$/gm;
    result = result.replace(spacesAndTabsAtStartAndEndOfLineRegex, '');

    result = result.trim();

    const unusualSeparatorsRegex = /[\u2028\u2029]/g;
    result = result.replace(unusualSeparatorsRegex, '');

    const replacementCharacterRegex = /�/g;
    result = result.replace(replacementCharacterRegex, '');

    return result;
}

export function removeHashtagsFromText(text: string, hashtags: string[]): string {
    let textWithNoHashtags = text;
    // We want to remove the longest hashtags first
    // for the case where there are 2 hashtags the start with the same string : #paris and #paris20
    const sortedHashtags = [...hashtags].sort((a, b) => b.length - a.length);
    sortedHashtags.forEach((hashtag) => {
        const hashtagText = hashtag.startsWith('#') ? hashtag : `#${hashtag}`;
        textWithNoHashtags = textWithNoHashtags.replace(new RegExp(`${hashtagText}`, 'g'), '');
    });
    return textWithNoHashtags.trim();
}

export function addHashtagsToText(text: string, hashtags: string[]): string {
    const selectedHashtagsText = hashtags.join(' ') ?? '';
    const textWithHashtags = selectedHashtagsText ? `${text}\n\n${selectedHashtagsText}` : text;
    return textWithHashtags;
}

export function removeAndAddHashtagsToText(text: string, hashtags: string[]): string {
    const cleanText = removeHashtagsFromText(text, hashtags);
    return addHashtagsToText(cleanText, hashtags);
}
